import PropTypes from 'prop-types';
import React from 'react';

import resizeImageSource from '../../helpers/resizeImageSource';
import Link from '../Link';
import * as S from './styled';
import { getHostname } from '../../helpers/getHostname';

const PersonSummary = ({
  name,
  slug,
  subtitle,
  photo,
  firstCharacter,
  isPost,
}) => {
  const url = isPost
    ? `${getHostname()}/profiel/${slug}`
    : `/personen/${firstCharacter}/${slug}`;

  return (
    <S.PersonSummaryContainer itemScope itemType="http://schema.org/Person">
      <Link href={url}>
        {!photo?.url && (
          <S.FallbackImage as="div">{firstCharacter}</S.FallbackImage>
        )}
        {photo?.url && (
          <S.PersonSummaryImage
            itemProp="image"
            src={resizeImageSource(photo?.url, 120, 1)}
            alt={photo?.altText}
          />
        )}
      </Link>

      <S.PersonSummaryContent>
        <Link href={url}>
          <S.PersonSummaryLink itemProp="name">{name}</S.PersonSummaryLink>
        </Link>
        <p itemProp="jobTitle">{subtitle}</p>
      </S.PersonSummaryContent>
    </S.PersonSummaryContainer>
  );
};

PersonSummary.propTypes = {
  name: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  slug: PropTypes.string.isRequired,
  firstCharacter: PropTypes.string.isRequired,
  isPost: PropTypes.bool,
  photo: PropTypes.shape({
    altText: PropTypes.string,
    url: PropTypes.string,
  }),
};

export default PersonSummary;
